module.exports = __webpack_public_path__ + "img/Icon-ionic-ios-person.e8149084.svg";